require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-101-for-account-holders.json") })
        }
      }, "path---article-101-for-account-holders");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-101-for-account-holders!./.cache/json/article-101-for-account-holders.json
// module id = 463
// module chunks = 231608221292675